import {
  CollisionDetection,
  closestCenter,
  pointerWithin,
  rectIntersection,
  getFirstCollision,
  UniqueIdentifier,
} from '@dnd-kit/core';
import { useCallback } from 'react';
import { ItemsI } from '../types';

/**
 * UseCollisionDetectionStrategy.
 */
export const useCollisionDetectionStrategy = ({
  activeId,
  lastOverId,
  items,
  recentlyMovedToNewContainer,
}: {
  activeId: UniqueIdentifier;
  lastOverId: React.MutableRefObject<UniqueIdentifier>;
  items: ItemsI;
  recentlyMovedToNewContainer: React.MutableRefObject<boolean>;
}): CollisionDetection => {
  return useCallback(
    (args) => {
      if (activeId in items) {
        return closestCenter({
          ...args,
          droppableContainers: args.droppableContainers.filter(
            ({ id }) => id in items,
          ),
        });
      }

      const pointerIntersections = pointerWithin(args);
      const intersections =
        pointerIntersections.length > 0
          ? pointerIntersections
          : rectIntersection(args);
      let overId = getFirstCollision(intersections, 'id');

      if (overId != null) {
        if (overId in items && items[overId].length > 0) {
          overId = closestCenter({
            ...args,
            droppableContainers: args.droppableContainers.filter(
              (container) =>
                container.id !== overId &&
                items[overId as any].includes(container.id), // FIXME: any
            ),
          })[0]?.id;
        }

        lastOverId.current = overId;

        return [{ id: overId }];
      }

      if (recentlyMovedToNewContainer.current) {
        lastOverId.current = activeId;
      }

      return lastOverId.current ? [{ id: lastOverId.current }] : [];
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeId, items],
  );
};
